import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    
    /** 获取系统图标信息 **/
    GET_SYS_ICON_ALL(data) {
        controller='EsSysIcon';
        action='GetSysIconAll';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 编辑系统图标 **/
    UPDATE_SYS_ICON(data) {
        controller='EsSysIcon';
        action='UpdateSysIcon';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

}